import { Box, IconButton } from '@mui/material';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';
import DownloadIcon from 'modules/common/components/Icons/DownloadIcon';
import { Document } from 'modules/common/interfaces/documents';
import useAuthSelectors from 'modules/Auth/AuthProvider/useAuthSelector';
import { useDocumenteDeleteMutation, useDownloadMutation } from 'modules/common/queries/documents';
import openDocument from 'modules/Documents/openDocument';

const DownloadButton = ({ id, file_name }) => {
    const { mutateAsync, isPending: isLoading } = useDownloadMutation(id);

    const handleDownload = async () => {
        const file = await mutateAsync();
        openDocument(file, file_name, true);
    };

    return (
        <IconButton
            size="small"
            color="secondary"
            onClick={handleDownload}
            disabled={isLoading}
            data-testid="document-download">
            <DownloadIcon fontSize="small" />
        </IconButton>
    );
};

const DeleteButton = ({ id, disabled }: { id: string; disabled?: boolean }) => {
    const { isEmployee } = useAuthSelectors('isEmployee');
    const { mutateAsync, isPending: isLoading } = useDocumenteDeleteMutation(id, isEmployee);

    const handleDelete = async () => {
        await mutateAsync();
    };

    return (
        <IconButton
            size="small"
            color="secondary"
            onClick={handleDelete}
            disabled={isLoading || disabled}
            data-testid="document-delete">
            <CloseXIcon fontSize="small" />
        </IconButton>
    );
};

const DocumentItemActions = ({ document, disabled }: { document: Document; disabled?: boolean }) => {
    return (
        <Box aria-label="Document item actions" sx={{ display: 'flex', alignItems: 'center' }}>
            <DownloadButton file_name={document.file_name} id={document.id ?? document.uuid} />
            <DeleteButton id={document.id ?? document.uuid} disabled={disabled} />
        </Box>
    );
};

export default DocumentItemActions;
